import { render } from "./laws.vue?vue&type=template&id=73e5b870&scoped=true"
import script from "./laws.vue?vue&type=script&lang=js"
export * from "./laws.vue?vue&type=script&lang=js"

import "./laws.vue?vue&type=style&index=0&id=73e5b870&scoped=true&lang=css"

import exportComponent from "D:\\Developpement\\HATPLC\\frontend 25122025\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e5b870"]])

export default __exports__